import { claimTypeValues } from '@/common/constants'

export const claimTypes = [
  {
    label: 'Marcado como "entregado" por el transportista, entrega sin completar',
    value: claimTypeValues.carrierMarkedDeliveredNotReceived,
  },
  {
    label: 'Paquete posiblemente perdido - Seguimiento sin actualizaciones recientes',
    value: claimTypeValues.possiblyLostNoTrackingUpdates,
  },
  { label: 'Entrega con daños visibles o productos faltantes', value: claimTypeValues.deliveredDamagedOrMissingItems },
  { label: 'Paquete retenido en aduanas', value: claimTypeValues.packageHeldAtCustoms },
]
